import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type TempBasalRateActivatedPayload = {
  percent?: number;
  duration?: number;
  temp_rate_id?: number;
};

export type TempBasalRateActivatedEvent = {
  percent?: number;
  duration?: number;
  tempRateId?: number;
};

const tempBasalRateActivatedSchema = z.object({
  percent: cz.permissive(z.number()),
  duration: cz.permissive(z.number()),
  temp_rate_id: cz.permissive(z.number()),
});

export const LID_TEMP_RATE_ACTIVATED = {
  value: 0x02,
  name: "Temporary Basal Rate Activated Event",
  format: "ff..h....",
  fields: ["percent", "duration", "temp_rate_id"],
  postprocess: rec => ({
    percent: rec.percent ? rec.percent / 100 : undefined,
    duration: rec.duration,
    tempRateId: rec.temp_rate_id,
  }),
  schema: tempBasalRateActivatedSchema,
} as const satisfies TandemEventDefinition<TempBasalRateActivatedPayload, TempBasalRateActivatedEvent>;
